import { css } from "styled-components"
import { colors } from "../../helpers/colors"

export const SectionWrapperStyles = css``
export const ContentWrapperStyles = css``
export const LeftColStyles = css`
  & .slick-slider {
    border: 1px solid ${colors.blue};
  }
`
export const RightColStyles = css``
